module.exports = __webpack_public_path__ + "static/img/icon2.4982c9dc.svg";